import FormContainer from '@components/FormContainer';
import Colors from '@constants/Colors';
import JobOfferRecruitmentForm from '@modules/JobOffers/JobOfferDetail/components/JobOfferRecruitmentForm';
import { Box, Chip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';

const ProcessChip = styled(Chip)(() => ({
    backgroundColor: Colors.NEUTRAL_BLACK,
    color: 'white',
    fontSize: '14px',
    fontWeight: 400,
    borderRadius: '16px',
    '& .MuiChip-label': {
        padding: '12px 16px',
        lineHeight: '1.4'
    }
}));

const StepNumber = styled(Box)(() => ({
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: Colors.PRIMARY_PURPLE,
    fontSize: '33px',
    fontFamily: 'Inter, sans-serif',
    fontWeight: 700,
    flexShrink: 0,
    lineHeight: 0
}));

const processData = {
    title: "Processus de recrutement",
    tags: [
        "Réponse en 48h",
        "Entretien dans l'établissement",
        "Entretien Visio"
    ],
    subtitle: "Déroulement des entretiens",
    steps: [
        "Un premier call avec Arthur (15 min) pour préqualifier le fit profil-poste",
        "Test de Soft Skills et Hard skills (3 à 15 min)",
        "Un entretien avec Emilie ta future manager",
        "Un entretien final avec David notre CEO"
    ]
};

const JobOfferRecruitmentProcess = ({ pro, jobOffer, onSubmit, loading }: { pro: any, jobOffer: any, onSubmit?: () => Promise<void>, loading?: boolean }) => {
    const [formState, setFormState] = useState<'view' | 'edit'>('view');
    const { getValues } = useFormContext();

    const handleCancel = () => {
        setFormState('view');
    };

    const handleSubmit = async () => {
        await onSubmit?.();
        setFormState('view');
    }

    return (
        <FormContainer
            formTitle={"Processus de recrutement"}
            formState={formState}
            setFormState={setFormState}
            loading={loading}
            onCancel={handleCancel}
            onSubmit={handleSubmit}
        >
            {formState === 'view' ? (
                <Box display="flex" flexDirection="column" gap="16px">

                    {/* Process Tags */}
                    <Box display="flex" flexWrap="wrap" gap="16px">
                        {getValues('recruitment.quickResponse') && <ProcessChip
                            label={"Réponse en 48h"}
                            size="small"
                        />}
                        {getValues('recruitment.place') && <ProcessChip
                            label={"Entretien dans l'établissement"}
                            size="small"
                        />}
                        {getValues('recruitment.mode') && <ProcessChip
                            label={"Entretien Visio"}
                            size="small"
                        />}
                    </Box>

                    {/* Steps Section */}
                    <Box display="flex" flexDirection="column" gap="16px" px="16px">
                        {/* Steps Title */}
                        <Typography
                            sx={{
                                color: 'white',
                                fontSize: '14px',
                                fontFamily: 'Plus Jakarta Sans, sans-serif',
                                fontWeight: 500,
                                lineHeight: '1.5'
                            }}
                        >
                            {getValues('recruitment.steps')?.length ? "Déroulement des entretiens" : "Processus de recrutement en cours de définition"}
                        </Typography>

                        {/* Steps List */}
                        {getValues('recruitment.steps')?.map((step, index) => (
                            <Box key={index} display="flex" gap="16px" alignItems="center">
                                <StepNumber>
                                    <Typography
                                        sx={{
                                            fontSize: '33px',
                                            fontWeight: 700,
                                            lineHeight: '1.4',
                                            whiteSpace: 'pre-wrap'
                                        }}
                                    >
                                        {index + 1}
                                    </Typography>
                                </StepNumber>
                                <Typography>
                                    {step}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
            ) : (
                <JobOfferRecruitmentForm pro={pro} />
            )}
        </FormContainer>
    );
};

export default JobOfferRecruitmentProcess;
